import React, { useState, useRef } from "react";
import dayjs from "../../util/dayjs-config";
import { Modal } from "react-bootstrap";
import microsoftImage from "../../assets/img/onboardingMicrosoftImage-141px-White.svg";
import videoImage from "../../assets/img/onboardingVideoImage-32px-Green.svg";
import microsoftButton from "../../assets/img/microsoftButton-200px-Black.svg";
import playButton from '../../assets/icons/Play-Icon-40px.svg';
import pauseButton from "../../assets/icons/Pause-Icon-40px.svg";
import video from "../../assets/videos/AboutTRIYO.mp4";
import "./GetStarted.scss";

const GetStarted = ({show, onHide, organizationName}) => {
    const heading= organizationName? `Welcome to ${organizationName} on TRIYO` : "Welcome to your organization on TRIYO";
    const introVideo = document.getElementById("intro-video");
    const videoRef = useRef(null);
    const [timeVideo, setTimeVideo] = useState("");
    const [playingVideo, setPlayingVideo] = useState(false);

    const humanizeDuration = (input, units) => {
        // units is a string with possible values of y, M, w, d, h, m, s, ms.
        // dayjs.add(amount, unit) requires the number first (moment was lenient
        // and accepted either order — TAD-5646 swap caught this).
        let duration = dayjs().startOf('day').add(input, units),
        format ="";
        if(duration.hour() > 0){ format += "H [h] "; }
        if(duration.minute() > 0){ format += "m [m] "; }
        format += " s [s]";
        return duration.format(format);
    }

    const openStoreTab = () => {
        window.open("https://appsource.microsoft.com/en-us/product/office/WA200003574?src=office", "_blank",  "noopener");
    }

    const videoHandler = () => {
        playingVideo ? videoRef.current.pause() : videoRef.current.play();
        setPlayingVideo(!playingVideo);
    };

    const showPlayButton = (
        <div className="video-controls-sub-container">
            <img
                onClick={() => videoHandler()}
                className={`video-controls ${playingVideo? "pause-control":"play-control"}`}
                alt={`${playingVideo? "Pause" : "Play"} video`}
                src={playingVideo? pauseButton : playButton}
            />
        </div>
    );

    return (
        <Modal show={show} onHide={onHide} className ="getstarted-modal-container" contentClassName="modal-styles" centered>
            <Modal.Header closeButton className="modal-header">
                <h4 className="panel-title">
                    {heading}
                </h4>
            </Modal.Header>
            <Modal.Body>
                <div className="split left">
                    <label className="smallText">{`Video · ${introVideo? timeVideo : "2 m 18 s"}`}</label>
                    <h5 className="bigText">Get up and running with TRIYO</h5>
                    <div className="video-container">
                        <video id="intro-video"
                            src={video}
                            ref={videoRef}
                            poster={videoImage}
                            onLoadedMetadata={() => { setTimeVideo(humanizeDuration(introVideo?.duration?.toString(), "s")) }}
                            onCanPlay={() => { setTimeVideo(humanizeDuration(introVideo?.duration?.toString(), "s")) }}
                        />
                        <div className="video-controls-container">{showPlayButton}</div>
                    </div>
                </div>
                <div className="split right">
                    <p className="smallText">Available on the Microsoft Store</p>
                    <h5 className="bigText">Download TRIYO’s Add-ins for Office </h5>
                    <body className="bottomText">Make the most of TRIYO, right from Word, PowerPoint and Excel.
                    <br/>
                    <br/>
                    Requires an active Microsoft 365 subscription.</body>

                    <div className="microsoftImage">
                        <img src={microsoftImage} onClick={openStoreTab} alt="micro-img" />
                        <div className="microsoftButton">
                            <img src={microsoftButton} onClick={openStoreTab} alt="micro-btn"/>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default GetStarted;
